import { SpaceVertical } from '@looker/components';

import ContentLoader from 'react-content-loader';

import { IncludeExcludeListLoader } from '../../IncludeExcludeFilter';

export const TreeLoader = () => (
  <SpaceVertical paddingTop="u3" gap="u4">
    <ContentLoader speed={2} viewBox="0 0 245 15">
      <rect x="0" y="0" rx="2" ry="2" width="245" height="15" />
    </ContentLoader>

    <IncludeExcludeListLoader />
  </SpaceVertical>
);
